import { GQLPlugin } from '../GQLTypes';

export const TransactionTrackingPlugin: GQLPlugin = ({ beforeRequest }, transactionId) => {
  beforeRequest.push(({ headers }) => {
    headers.set('X-Transaction-ID', transactionId);
  });
};
